import {
  Landmark,
  FileText,
  Briefcase,
  Building2,
  Shield,
  Globe2,
  TrendingUp,
  Layers,
  CheckCircle,
  Target,
  MapPin,
  ArrowRight
} from "lucide-react";

export default function GovernmentInfrastructureAdvisory() {
  const sections = [
    {
      id: "pmc-services",
      title: "Project Management Consultancy (PMC) Services",
      subtitle: "Central & State Government Projects",
      icon: Landmark,
      heroImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: Target,
          title: "End-to-End Project Management Consultancy",
          description: "Comprehensive PMC for government infrastructure projects",
          points: [
            "End-to-end PMC services for Central and State Government projects",
            "Project planning, scheduling, and milestone management",
            "Cost estimation, budgeting, and financial control",
            "Procurement and contract management support",
            "Quality assurance, monitoring, and reporting",
            "Risk management and mitigation planning",
            "Coordination with government departments, contractors, and stakeholders",
            "Project monitoring, evaluation, and closure support"
          ],
          image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80&auto=format&fit=crop"
        },
        {
          icon: Layers,
          title: "Sector-Specific PMC Services",
          description: "Specialized project management across sectors",
          points: [
            "Infrastructure and urban development projects",
            "Smart cities, housing, and urban renewal projects",
            "Transportation, roads, and logistics projects",
            "Energy, renewable energy, and power projects",
            "Water, sanitation, and environmental projects",
            "Healthcare, education, and social infrastructure projects"
          ],
          image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "dpr-feasibility",
      title: "Detailed Project Report (DPR) Preparation & Feasibility Studies",
      subtitle: "Comprehensive project planning and viability assessment",
      icon: FileText,
      heroImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: FileText,
          title: "DPR Preparation & Analysis",
          description: "Professional DPR preparation aligned with government standards",
          points: [
            "Preparation of Detailed Project Reports (DPRs) for government projects",
            "Techno-economic feasibility studies",
            "Financial modeling and viability analysis",
            "Environmental and social impact assessment support",
            "Cost-benefit analysis and funding structure advisory",
            "Assistance with approvals from relevant ministries and authorities",
            "DPR updates, revisions, and compliance with government guidelines"
          ],
          image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "government-advisory",
      title: "Government Advisory & Consultancy Services",
      subtitle: "Strategic policy and procurement advisory",
      icon: Briefcase,
      heroImage: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: Briefcase,
          title: "Policy, Program & Scheme Advisory",
          description: "Strategic advisory for government programs and schemes",
          points: [
            "Advisory on formulation and implementation of government schemes",
            "Program management and institutional strengthening advisory",
            "Monitoring & Evaluation (M&E) of government programs",
            "Public finance, budgeting, and expenditure optimization advisory"
          ],
          image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800&q=80&auto=format&fit=crop"
        },
        {
          icon: FileText,
          title: "Procurement, Tender & Contract Advisory",
          description: "Expert support for government procurement processes",
          points: [
            "Advisory on government procurement and tendering processes",
            "Drafting and review of RFPs, RFQs, EOIs, and bid documents",
            "Bid evaluation and technical/commercial assessment support",
            "Contract structuring and performance monitoring advisory"
          ],
          image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "ppp-advisory",
      title: "Public-Private Partnership (PPP) Advisory",
      subtitle: "Structuring and implementing PPP projects",
      icon: Building2,
      heroImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: Building2,
          title: "PPP Project Structuring & Advisory",
          description: "Comprehensive PPP project design and structuring",
          points: [
            "Identification and structuring of projects under PPP models",
            "Advisory on BOT, BOOT, DBFOT, HAM, EPC, and hybrid models",
            "Risk allocation and concession framework advisory",
            "Financial structuring and viability gap funding (VGF) advisory"
          ],
          image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80&auto=format&fit=crop"
        },
        {
          icon: CheckCircle,
          title: "Transaction & Implementation Advisory",
          description: "End-to-end support for PPP transaction execution",
          points: [
            "Preparation of concession agreements and bid documents",
            "Support during bidding, evaluation, and award stages",
            "Stakeholder coordination between public authorities and private players",
            "Post-award PPP contract management and monitoring advisory"
          ],
          image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "liaison-regulatory",
      title: "Government Liaison & Regulatory Advisory",
      subtitle: "Navigating government approvals and compliance",
      icon: Shield,
      heroImage: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: Shield,
          title: "Regulatory Advisory & Liaison",
          description: "Expert guidance on government clearances and compliance",
          points: [
            "Liaison with Central and State Government departments",
            "Advisory on statutory approvals, clearances, and licenses",
            "Assistance with land acquisition, utility shifting, and permissions",
            "Advisory on compliance with applicable government regulations"
          ],
          image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "business-setup",
      title: "Business Setup Advisory Across All States in India",
      subtitle: "End-to-End Pan-India Support",
      icon: Globe2,
      heroImage: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: Briefcase,
          title: "Business Structuring & Entry Advisory",
          description: "Strategic business establishment across India",
          points: [
            "Advisory on entity structure (company, LLP, partnership, branch, etc.)",
            "State-wise regulatory and compliance mapping",
            "Sector-specific licensing and approval advisory",
            "Investment policy and incentive advisory"
          ],
          image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80&auto=format&fit=crop"
        },
        {
          icon: FileText,
          title: "Pan-India Registration & Compliance Support",
          description: "Comprehensive registration and compliance services",
          points: [
            "Company and LLP incorporation across India",
            "State-wise registrations (GST, Shops & Establishment, labor laws, etc.)",
            "Industry-specific licenses and approvals",
            "Ongoing statutory, regulatory, and compliance support"
          ],
          image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80&auto=format&fit=crop"
        },
        {
          icon: MapPin,
          title: "Location & Expansion Advisory",
          description: "Strategic site selection and expansion planning",
          points: [
            "State selection and comparative analysis",
            "Advisory on industrial policies, subsidies, and incentives",
            "Land, infrastructure, and industrial park advisory",
            "Expansion, branch, and office setup support"
          ],
          image: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "incentive-advisory",
      title: "Government Scheme & Incentive Advisory",
      subtitle: "Maximizing government benefits and subsidies",
      icon: TrendingUp,
      heroImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: TrendingUp,
          title: "Incentive Structuring & Realization",
          description: "Expert advisory on government schemes and benefits",
          points: [
            "Advisory on Central and State Government schemes and subsidies",
            "Assistance with applications, documentation, and approvals",
            "Incentive structuring and compliance advisory",
            "Monitoring and realization of incentives and benefits"
          ],
          image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80&auto=format&fit=crop"
        }
      ]
    },
    {
      id: "integrated-consultancy",
      title: "Integrated End-to-End Consultancy Support",
      subtitle: "Comprehensive project lifecycle management",
      icon: Layers,
      heroImage: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&q=80&auto=format&fit=crop",
      subsections: [
        {
          icon: Layers,
          title: "Comprehensive Project Support",
          description: "Single-point solution for complex government projects",
          points: [
            "Concept-to-commissioning advisory for government projects",
            "Single-point coordination for multi-disciplinary consulting services",
            "Multi-state and multi-agency project management support",
            "Advisory across project lifecycle: planning, execution, and monitoring"
          ],
          image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80&auto=format&fit=crop"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Government, Infrastructure & Project Advisory Services
            </h1>
            <p className="text-xl md:text-2xl text-yellow-50 mb-4">
              Central Government, State Governments & Public Sector Entities
            </p>
            <p className="text-yellow-100 text-lg">
              Comprehensive advisory across PMC, DPR preparation, PPP structuring, government liaison, 
              and pan-India business setup
            </p>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
            Your Strategic Partner for Government Projects
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            We provide end-to-end advisory services to Central and State Governments, PSUs, and 
            public sector entities across infrastructure development, project management, policy 
            implementation, and regulatory compliance
          </p>
          <p className="text-gray-600">
            Our services span the entire project lifecycle from feasibility and DPR preparation 
            through execution, monitoring, and closure, ensuring successful delivery of government initiatives.
          </p>
        </div>
      </section>

      {/* Render Each Section */}
      {sections.map((section, sectionIndex) => (
        <div key={section.id}>
          {/* Section Hero */}
          <section className={`py-16 ${sectionIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className={`grid lg:grid-cols-2 gap-8 items-center ${sectionIndex % 2 === 0 ? '' : 'lg:grid-flow-dense'}`}>
                <div className={sectionIndex % 2 === 0 ? '' : 'lg:col-start-2'}>
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-700 rounded-full text-sm font-semibold mb-4">
                    <section.icon className="w-4 h-4" />
                    <span>Service Area {sectionIndex + 1}</span>
                  </div>
                  <h2
                    className="text-3xl md:text-4xl font-bold mb-4 text-black"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {section.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6">
                    {section.subtitle}
                  </p>
                  <div className="flex gap-4">
                    <a
                      href="/contact"
                      className="px-6 py-3 bg-yellow-600 text-white font-semibold rounded-lg hover:bg-yellow-700 transition-all duration-300"
                    >
                      Request Proposal
                    </a>
                  </div>
                </div>
                <div className={`rounded-2xl overflow-hidden shadow-2xl ${sectionIndex % 2 === 0 ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
                  <img
                    src={section.heroImage}
                    alt={section.title}
                    className="w-full h-96 object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Subsections */}
          <section className={`py-16 ${sectionIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className={`grid ${section.subsections.length === 1 ? 'md:grid-cols-1 max-w-4xl mx-auto' : 'md:grid-cols-2'} gap-8`}>
                {section.subsections.map((subsection, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-500 group"
                  >
                    {/* Image */}
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={subsection.image}
                        alt={subsection.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute bottom-4 left-4 flex items-center gap-3">
                        <div className="p-3 bg-yellow-500 rounded-lg">
                          <subsection.icon className="w-6 h-6 text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-white">
                          {subsection.title}
                        </h3>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <p className="text-yellow-600 font-semibold text-sm mb-4">
                        {subsection.description}
                      </p>
                      <ul className="space-y-2">
                        {subsection.points.map((point, idx) => (
                          <li key={idx} className="flex items-start gap-2">
                            <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                            <span className="text-gray-600 text-sm leading-relaxed">
                              {point}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      ))}

      {/* Key Metrics */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
              Our Track Record
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">500+</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Projects Delivered</h3>
              <p className="text-gray-600">Across Central and State Governments</p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">₹50,000Cr+</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Project Value</h3>
              <p className="text-gray-600">Infrastructure projects managed</p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">28</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">States Covered</h3>
              <p className="text-gray-600">Pan-India presence and expertise</p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-yellow-600">25+</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">Years Experience</h3>
              <p className="text-gray-600">Government advisory expertise</p>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-12 bg-black">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="flex items-start gap-4">
            <div className="mt-1">
              <Shield className="w-7 h-7 text-yellow-500 flex-shrink-0" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">
                Important Disclaimer
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed">
                All government, infrastructure, and project advisory services are subject to 
                applicable laws, policies, and approvals of the respective Central and State 
                Government authorities. Final decisions and approvals rest solely with competent 
                government departments and regulatory bodies
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Partner With Us for Your Next Government Project
          </h2>
          <p className="text-lg text-yellow-50 mb-8">
            Whether you need PMC services, DPR preparation, PPP structuring, or pan-India business 
            setup advisory, our team is ready to support your initiatives
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg"
            >
              Request Detailed Proposal
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            <a
              href="mailto:info@hawkinsandbrooks.com"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-yellow-600 transition-all duration-300"
            >
              Email Government Desk
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
